module.exports = __webpack_public_path__ + "img/202109.9d179d4c.png";